import { Component } from 'react';

import classNames from 'classnames';
import ReactDOM from 'react-dom';

import styles from './IwModal.module.css';
import * as DevOps from '../../devOpsHelper/DevOps';
import { CloseSVG } from '../../svgComponents/closeSVG';

const MODAL_ANIMATION_TIME_MS = 200;

class IwModal extends Component {
    constructor(props) {
        super(props);
        this.bodyElement = document.querySelector('body');
        //TODO provide a fallback in case root element do not exists
        this.rootElement = document.getElementById('root');
        this.modalDOMElement = document.createElement('div');
        this.shouldClose = true;
        this.state = {
            backgroundStyles: styles.backgroundBeforeOpen,
            contentStyles: styles.contentBeforeOpen,
            contentInnerStyles: classNames(
                props.contentStyles,
                styles.contentInner
            )
        };
    }

    componentDidMount = () => {
        const { isOpen } = this.props;
        if (this.rootElement) {
            this.rootElement.appendChild(this.modalDOMElement);
        }
        document.addEventListener('keydown', this.handleKeyDown, false);
        this.setState({
            shouldRender: isOpen,
            contentStyles: this.setContentStyles(styles.contentBeforeOpen)
        });
    };

    // eslint-disable-next-line react/no-unsafe
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.delayRenderForAnimation(nextProps);
    }

    componentDidUpdate() {
        const { isOpen } = this.props;

        if (
            isOpen &&
            this.state.backgroundStyles !== styles.backgroundAfterOpen
        ) {
            window.requestAnimationFrame(() => {
                // Firefox will sometimes merge changes that happened here
                window.requestAnimationFrame(() => {
                    this.setState({
                        backgroundStyles: styles.backgroundAfterOpen,
                        contentStyles: this.setContentStyles(
                            styles.contentAfterOpen
                        )
                    });
                });
            });
        }
    }

    componentWillUnmount() {
        if (this.rootElement) {
            this.rootElement.removeChild(this.modalDOMElement);
        }
        this.bodyElement.style.overflow = 'auto';
        document.removeEventListener('keydown', this.handleKeyDown, false);
    }

    handleCloseIconClick = () => {
        this.shouldPopupClose();
    };

    handleBackgroundClick = () => {
        if (this.props.removeClose) {
            return;
        }

        this.shouldPopupClose();
    };

    handleContentClick = () => {
        this.shouldClose = false;
    };

    handleKeyDown = (event) => {
        const { isOpen, onClose, removeClose } = this.props;

        const ESC_KEY_CODE = 27;

        if (
            isOpen &&
            event.keyCode === ESC_KEY_CODE &&
            onClose &&
            !removeClose
        ) {
            onClose();
        } else {
            return;
        }
    };

    setContentStyles = (stylesToAdd) => {
        const { contentStyles } = this.props;

        if (contentStyles) {
            const stylesToAddArray = stylesToAdd.split(' ');

            stylesToAddArray.push(contentStyles);

            let classNamesToReturn = classNames.apply(null, stylesToAddArray);

            return classNamesToReturn;
        } else {
            return stylesToAdd;
        }
    };

    delayRenderForAnimation = (nextProps) => {
        const { isOpen } = this.props;
        if (isOpen && !nextProps.isOpen) {
            this.setState({
                backgroundStyles: styles.backgroundBeforeOpen,
                contentStyles: this.setContentStyles(styles.contentBeforeOpen)
            });

            if (DevOps.isProductionEnv()) {
                setTimeout(() => {
                    this.bodyElement.style.overflow = 'auto';
                    this.setState({ shouldRender: false });
                }, MODAL_ANIMATION_TIME_MS);
            } else {
                this.bodyElement.style.overflow = 'auto';
                this.setState({ shouldRender: false });
            }
        }

        if (!isOpen && nextProps.isOpen) {
            this.bodyElement.style.overflow = 'hidden';
            this.setState({ shouldRender: true });
        }
    };

    shouldPopupClose = () => {
        const { onClose } = this.props;
        if (this.shouldClose) {
            onClose();
        }
        this.shouldClose = true;
    };

    renderClose() {
        if (this.props.removeClose) {
            return null;
        }

        return (
            <div
                data-testid="close-modal"
                className={styles.close}
                onClick={this.handleCloseIconClick}
            >
                <CloseSVG />
            </div>
        );
    }

    renderModal() {
        const { backgroundStyles, contentStyles, contentInnerStyles } =
            this.state;

        return (
            <div
                className={backgroundStyles}
                onClick={this.handleBackgroundClick}
            >
                <div
                    data-testid="modal-content"
                    className={contentStyles}
                    onClick={this.handleContentClick}
                >
                    <div
                        data-testid="modal-inner-content"
                        className={contentInnerStyles}
                    >
                        {this.renderClose()}
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { shouldRender } = this.state;
        return shouldRender
            ? ReactDOM.createPortal(this.renderModal(), this.modalDOMElement)
            : null;
    }
}

// eslint-disable-next-line import/no-default-export
export default IwModal;
